import React from 'react'
import injectSheet from 'react-jss'
import LPMenu from '../lp-menu/lp-menu.container'

const SubHeader = injectSheet({
  subHeader: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    backgroundColor: '#fff',
    flexShrink: '0',
    height: '70px',
    '@media (max-width: 1023px)': {
      display: 'none'
    }
  },
  holder: {
    position: 'absolute',
    left: '0',
    top: '0',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '18px 0 18px 20px',
    '@media (max-width: 575px)': {
      padding: '0'
    }
  },
  back: {
    textDecoration: 'none',
    color: 'var(--blue)',
    fontWeight: 'bold',
    '& svg': {
      margin: '-2px -4px 0 0'
    },
    '@media (max-width: 575px)': {
      display: 'none'
    }
  }
})(({ classes, children }) => {
  return (
    <div className={classes.subHeader}>
      {children}
      <LPMenu />
    </div>
  )
})

export default SubHeader
